import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import './CopyrightSelectCard.scss';

interface ICopyrightSelectCardProps {
  copyright: string;
  isSelected?: boolean;
  onClick?: (copyright: string) => void;
  disabled?: boolean;
}

const CopyrightSelectCard = ({
  copyright,
  isSelected,
  onClick,
  disabled,
}: ICopyrightSelectCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames('copyright-select-card', { isSelected, disabled })}
      onClick={() => !disabled && onClick && onClick(copyright)}
    >
      <div className="copyright-select-card-header">{copyright}</div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default CopyrightSelectCard;
